<template>
  <v-combobox
    v-model="val"
    :items="optionsToRender"
    :outlined="outlined"
    :dense="dense"
    :readonly="readonly"
    :label="renderLabel ? renderLabel + ' (Auswahl oder Eingabe)' : void 0"
    :class="renderClasses"
    ref="combobox"
    @change="onChange"
    :chips="filterMode"
    :deletable-chips="filterMode"
  />
</template>

<script>
import InputMixin from './mixins/InputMixin'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  props: {
    options: {
      type: Array,
      default: _ => []
    },

    filterMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    optionsToRender () {
      return this.isValueTypeValid(this.val) && this.options && !this.options.includes(this.val)
        ? [].concat(this.val, this.options)
        : this.options
    }
  },

  methods: {
    onChange () {
      this.$nextTick(_ => {
        this.$refs && this.$refs.combobox
          ? this.$refs.combobox.blur()
          : void 0
      })
    },

    isValueTypeValid (value) {
      return typeof value === 'number' || typeof value === 'string'
    }
  }
}
</script>
